<template>
  <div class='hj-container'>
    <header-layout activeIndex="productIntroduction"></header-layout>
    <div class="">
      <img src="../../assets/img/productIntroduction/productIntroduction_02.jpg" class="bg2-rowImg" width="100%"/>
    </div>
    <div class="productIntroduction">
      <img src="../../assets/img/productIntroduction/productIntroduction_04.jpg" class="bg2-rowImg" width="100%"/>
      <img src="../../assets/img/companyDevelopt/y_24.jpg" width="100%"/>
    </div>
    <el-footer style='padding:0;'>
      <footer-layout></footer-layout>
    </el-footer>

  </div>
</template>

<script>
import HeaderLayout from '@/components/pc/HeaderLayout.vue';
import FooterLayout from '@/components/pc/FooterLayout.vue';

export default {
  name: "",
  components: {HeaderLayout, FooterLayout},
  data() {
    return {}
  },
  mounted() {

  },
  methods: {}
}
</script>

<style lang='scss' scoped>
#hj-container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;

}

.productIntroduction {
  background-color: #F7F8FB;
  padding-top: 30px;

}
</style>
